export default __webpack_public_path__ + "static/media/kitchen5-afterD.75b4ba71.jpg";